import { apiClient } from "../config";

async function getProgramCodeValidation(code: any, programId?: any) {
  const params: any = { code };
  if (programId) {
    params.programId = programId;
  }

  const res = await apiClient.get(`/admin/programs/code-validation`, {
    params,
  });

  return res.data;
}

export default getProgramCodeValidation;
